import { KYMW9000Model } from '../kymw9000.model';
import { UserIDModel } from '../vo/user-id.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ユーザーを削除
 *
 * @export API通信成功時の処理
 * @class DeleteUserService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteAssociatedUserManagementSevice extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9000Model;
  private successFunc: Function;
  private vo: UserIDModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteUserService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      delete: {
        deleteAssociatedUserManagement: {
          condition: {
            AssociatedUserId: this.vo.associatedUserId,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof DeleteAssociatedUserManagement
   */
  execute(model: KYMW9000Model, vo: UserIDModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteAssociatedUserManagement', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteAssociatedUserManagement
   */
  success(data: any) {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
